import React from "react"
import { useInViewEffect } from "react-hook-inview"
import lottie from "lottie-web"
import lDetailBg from "../public/l-detail-bg.json"
import { useEffect, useState, useRef } from "react"
import { checkIfAppleDevice, checkIfFirefox } from "../lib/frontend-helpers"
import { checkIfIOS } from "../lib/frontend-helpers"
import { useTheme } from "next-themes"

const chars = {
  light: [
    '/who-light-0.webp',
    '/who-light-7.webp',
    '/who-light-2.webp',
    '/who-light-8.webp',
    '/who-light-4.webp',
    '/who-light-5.webp',
    '/who-light-6.webp',
  ],
  dark: [
    '/who-dark-0.webp',
    '/who-dark-1.webp',
    '/who-dark-2.webp',
    '/who-dark-3.webp',
    '/who-dark-4.webp',
    '/who-dark-5.webp',
    '/who-dark-6.webp',
  ]
}

const HomeWho = () => {
  const [isAppleDevice, setIsAppleDevice] = useState(false)
  const [isIOS, setIsIOS] = useState(false)
  const { theme } = useTheme()

  const ref = useInViewEffect(
    ([entry], observer) => {
      const lastY = observer.lastY || -1
      const newY = entry.boundingClientRect.y

      // once we leave, perform an action
      if (entry.isIntersecting === true) {
        const pFactions = document.querySelector(
          ".faction.chosen .factions-mf-img"
        )
        if (!pFactions) return
        if (newY < lastY) {
          // pFactions.classList.add("slide-down")
        } else {
          // console.log("who - onEnter - up")
          document.querySelectorAll(".factions-mf-img").forEach((e) => {
            e.play()
            e.classList.remove("opacity-0")
          })
          // pFactions.classList.remove("magic-poof")
        }
      } else {
        const pFactions = document.querySelector(
          ".faction.chosen .factions-mf-img"
        )
        if (!pFactions) return
        if (newY > lastY) {
          // console.log("who - onLeave - up")
          // pFactions.classList.remove("slide-down")
        } else {
          // console.log("who - onLeave - down")
          document.querySelectorAll(".factions-mf-img").forEach((e) => {
            e.pause()
            e.classList.add("opacity-0")
          })
        }
      }

      observer.lastY = newY
    },
    { threshold: 0.5 }
  )

  const SSR = typeof window === "undefined"

  useEffect(() => {
    if (SSR) return
    const isApple = checkIfAppleDevice(window)
    const isIOS = checkIfIOS(window)
    const isFF = checkIfFirefox(window)
    setIsAppleDevice(isApple)
    setIsIOS(isIOS)

    if (isApple || isIOS || isFF) return // don't play animation on Safari, iOS

    const anim = lottie.loadAnimation({
      container: document.querySelector(".l-detail-bg"),
            loop: true,
      autoplay: true,
      animationData: lDetailBg,
    })
    anim.setSpeed(0.25)
  }, [SSR])

  return (
    <div
      className="p-who relative min-h-[100vh] w-full overflow-hidden md:overflow-auto"
      style={{
        backgroundImage:
          "url(/bg-details--gradient.png), url(/bg-details--pattern.webp)",
        backgroundPosition: "left top",
        backgroundRepeat: "repeat-x, repeat",
      }}
      id="p-who"
      data-scroll-section
    >
      <div
        className="absolute left-0 top-1 h-full w-1"
        data-scroll
        data-scroll-repeat
        data-scroll-call="sceneChange"
        attr-scene="who"
        id="scene-who"
      />
      <div className="c-fixed_wrapper" data-scroll data-scroll-repeat>
        <div>
          <div
            data-scroll
            data-scroll-speed="4"
            className=" relative mx-4 mt-16 w-[90%] max-w-screen-xl overflow-hidden rounded-3xl bg-[rgba(36,32,40,0.54)] p-4
               text-white
                shadow-xl
                md:mx-auto
                md:mb-[60vh]
                md:mt-56
                md:w-[80%]
                md:p-32"
            style={{
              borderColor: "rgba(254, 252, 249, 0.15)",
              borderWidth: "1px",
            }}
          >
            <div className="l-detail-bg absolute right-[5%] -bottom-[5%] h-[130%] opacity-[0.05]" />
            {isAppleDevice === true && (
              <svg
                data-scroll
                className="absolute right-[10%] bottom-10 h-[40%] opacity-[0.05] md:h-[110%]"
                viewBox="0 0 1686 2394"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M913.535 20.0292C965.603 7.26808 1020.82 -0.254544 1076.59 0.00659706C1177.34 -0.464285 1280.19 24.2258 1369.83 89.1202C1558.37 225.622 1586.98 402.214 1579.76 551.71C1652.46 624.259 1689.86 722.774 1656.57 814.2C1646.18 842.731 1629.98 867.42 1609.54 888.129L1609.8 888.494L1607.61 890.061C1590.96 906.508 1571.6 920.38 1550.33 931.609C1509.6 961.893 1491.15 978.276 1475.81 996.906C1464.95 1010.1 1455.31 1024.87 1440.38 1048.32L1436.86 1053.87L1436.82 1053.92C1422.55 1076.35 1404.21 1105.19 1377.48 1144.21C1330.57 1212.67 1265.07 1240.29 1201.75 1239.44C1171.9 1239.85 1142.39 1233.85 1115.41 1222.76C1045.44 1193.99 986.436 1127.67 985.75 1046.25C982.17 1046.18 978.608 1046.13 975.047 1046.12C637.354 1047.59 356.073 1313.27 339.225 1654.66C321.798 2007.74 593.833 2308.09 946.837 2325.53C956.628 2326.01 966.383 2326.27 976.09 2326.31C1313.77 2324.84 1595.06 2059.16 1611.9 1717.77C1621.43 1524.81 1544.54 1347.62 1415.11 1223.67C1401.62 1210.75 1401.16 1189.33 1414.08 1175.83C1421.42 1168.15 1431.51 1164.69 1441.33 1165.51C1450.66 1164.73 1460.25 1167.8 1467.55 1174.79C1610.53 1311.72 1695.65 1507.73 1685.12 1721.11C1666.4 2100.6 1352.17 2395.47 976.146 2393.99C963.451 2394.04 950.69 2393.75 937.857 2393.12C547.537 2373.84 246.741 2041.73 266.009 1651.32C284.738 1271.84 598.963 976.96 974.99 978.436C981.719 978.417 988.475 978.483 995.241 978.643C1014.46 868.822 1013.57 770.444 1006.17 697.653C1003.47 684.973 1001.85 672.16 1001.39 659.309C1000.78 655.26 1000.16 651.329 999.517 647.52L1001.28 647.225C1001.74 625.339 1005.64 603.431 1013.45 581.973C1033.01 528.287 1073.23 488.104 1123.58 462.546C1113.25 429.028 1093.21 402.037 1059.37 386.167C1029.63 372.222 1001.23 366.049 974.718 365.641C944.591 366.105 917.03 373.988 892.936 386.255C844.996 410.66 811.646 451.995 799.936 486.593C794.845 501.633 780.216 510.745 765.077 509.469C760.586 509.847 755.947 509.329 751.406 507.791C733.709 501.799 724.221 482.591 730.211 464.89C748.058 412.165 794.281 357.671 856.609 325.942C891.405 308.227 931.503 297.471 974.802 297.958C1012.4 297.534 1052.51 305.559 1093.73 324.894C1169.32 360.347 1197.72 429.921 1204.2 495.251C1207.28 526.239 1205.65 557.516 1201.49 586.253C1199.09 618.168 1195.69 634.305 1190.77 651.356C1184.66 672.505 1191.61 689.997 1206.52 695.305C1207.61 695.693 1208.71 696.013 1209.82 696.265C1210.88 696.507 1211.95 696.683 1213.02 696.796C1221.54 695.878 1229.72 690.745 1235.54 681.053C1250.15 624.125 1260.16 552.056 1253.32 482.964C1244.41 392.939 1207.94 313.587 1121.87 273.109C1068.95 248.225 1018.17 237.381 970.743 236.969C916.629 237.44 866.995 251.456 823.677 273.567C739.73 316.416 680.367 389.249 658.988 452.577C653.906 467.63 639.271 476.756 624.122 475.48C619.64 475.858 615.009 475.342 610.476 473.811C592.776 467.834 583.271 448.633 589.248 430.927C616.735 349.505 688.93 263.491 787.285 213.287C841.322 185.705 903.521 168.804 970.827 169.289C1029.36 168.867 1091.87 181.57 1156.29 211.865C1271.68 266.132 1316.03 372.573 1326.29 476.299C1335.83 572.713 1316.81 671.606 1294.9 738.49C1294.66 750.615 1302.19 762.036 1314.27 766.182C1315.66 766.659 1317.07 767.025 1318.48 767.281C1319.24 767.418 1319.99 767.524 1320.75 767.599C1331.56 766.523 1341.29 759.314 1345.04 748.363C1352.92 725.368 1360.31 697.585 1366.1 666.788C1367 659.853 1367.93 652.863 1368.87 645.811C1371.61 625.29 1374.4 604.337 1376.67 583.042C1376.87 579.905 1377.06 576.755 1377.22 573.594L1377.63 573.732C1382.13 527.845 1383.81 480.442 1376.89 432.399C1364.86 348.939 1326.53 263.62 1225.69 187.566C1156.8 135.606 1075.6 114.196 994.64 113.712C961.74 113.909 928.93 117.525 897.055 123.915C783.642 146.652 690.099 201.891 652.256 253.068C645.02 262.853 633.51 268.551 622.213 267.609C614.323 268.266 606.169 266.17 599.304 261.091C598.326 260.368 597.182 259.42 596.523 258.8L596.164 258.472C596.076 258.396 595.993 258.331 595.892 258.253L595.558 258.002C595.266 257.784 594.828 257.457 594.074 256.876C579.273 245.469 579.339 222.343 590.742 207.539C648.859 132.094 770.07 55.1892 913.535 20.0292ZM1082.67 605.133C1091.98 579.559 1108.94 557.439 1132.28 539.918C1131.41 562.828 1128.08 585.294 1123.6 605.285C1119.04 611.731 1115.46 618.733 1112.97 626.266C1089.95 695.976 1169.25 784.845 1290.07 824.762C1330.62 838.157 1370.7 844.337 1406.93 844.002C1481.29 844.686 1540.48 818.336 1556.17 770.815C1560.22 758.532 1561.1 745.654 1559.14 732.554C1559.41 731.406 1559.63 730.231 1559.79 729.034C1560.48 723.649 1561.23 718.132 1562 712.492L1564.4 695.214L1564.41 695.141L1564.42 695.108L1564.43 695.056L1564.54 694.236V694.214C1566.28 681.838 1568.08 668.95 1569.83 655.62C1596.18 701.652 1602.41 749.707 1587.36 791.041C1580.97 808.6 1570.94 824.56 1557.71 838.52C1538.98 851.923 1522.76 863.623 1508.56 874.122C1497.12 879.793 1484.7 884.615 1471.37 888.503C1447.58 895.449 1421.32 899.246 1393.59 899.488C1355.1 899.154 1313.93 892.01 1272.69 876.985C1199.5 850.325 1142.47 804.828 1108.82 754.374C1093.98 732.118 1083.91 709.342 1078.71 686.921C1077.48 675.259 1076.09 664.201 1074.59 653.792C1074.35 636.973 1077.03 620.621 1082.67 605.133ZM1324.51 143.941C1525.16 289.205 1517.83 482.03 1497.55 641.988L1497.23 641.7L1496.87 641.373C1492.14 675.685 1486.6 705.214 1481.76 727.172C1479.03 739.593 1468.63 748.343 1456.63 749.538C1455.5 749.426 1454.38 749.248 1453.25 748.999C1437.79 745.593 1428.02 730.296 1431.42 714.835L1431.97 712.329L1432.68 709.026C1433.64 704.513 1434.62 699.714 1435.61 694.649C1436.41 692.38 1436.99 689.991 1437.3 687.505L1437.64 684.805C1437.74 683.931 1437.85 683.054 1437.97 682.175L1437.99 682.03C1442.09 659.491 1446.2 632.785 1449.48 603.512C1455.82 548.163 1458.53 485.456 1449.49 422.745C1435.1 322.863 1388.14 221.077 1272.07 133.532C1239.99 109.332 1205.93 90.8344 1170.86 77.221C1225.11 88.3731 1277.3 109.762 1324.51 143.941ZM1243.9 940.576C1294.1 958.867 1345.16 967.514 1393.63 967.166C1398.36 967.204 1403.05 967.147 1407.72 967.016C1397.91 980.297 1388.58 994.819 1377.67 1011.97C1376.52 1013.78 1375.34 1015.62 1374.15 1017.51L1373.93 1017.85C1359.74 1040.15 1341.98 1068.07 1316.03 1105.95C1284.69 1151.68 1242.97 1171.02 1201.64 1171.85C1182.82 1171.48 1164.2 1167.33 1146.77 1160.16C1087.07 1135.62 1049.57 1079.96 1061.32 1022.88C1074.89 957.043 1081.51 894.48 1083.59 837.636C1124.98 881.107 1179.93 917.27 1243.9 940.576Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M326.391 225.011C328.928 224.579 331.467 224.502 333.947 224.752C344.561 223.683 354.946 228.714 360.661 237.853L409.458 315.873L495.544 299.785C497.146 299.486 498.75 299.329 500.342 299.307C501.417 299.292 502.487 299.339 503.546 299.446C514.561 298.337 525.306 303.801 530.858 313.551C536.802 323.999 535.474 337.069 527.547 346.104L461.092 421.84L517.374 495.281C524.744 504.899 525.146 518.152 518.374 528.2C512.503 536.908 502.379 541.521 492.181 540.493C488.781 540.837 485.282 540.563 481.848 539.613L378.15 510.938L305.823 580.875C299.725 586.772 291.479 589.471 283.402 588.659C277.885 589.213 272.192 588.144 267.078 585.349C256.252 579.434 250.529 567.167 252.948 555.068L274.082 449.43L200.145 406.371C190.153 400.552 184.726 389.217 186.458 377.781C188.189 366.345 196.727 357.126 207.994 354.526L283.209 337.173L303.622 246.607C306.137 235.458 315.128 226.928 326.391 225.011ZM339.951 366.869L347.702 332.483L366.8 363.019C372.523 372.168 382.915 377.188 393.514 376.121C393.77 376.148 394.027 376.169 394.283 376.189L394.583 376.209L394.885 376.227L395.586 376.254C397.549 376.305 399.534 376.152 401.517 375.782L424.642 371.46L397.82 402.03C388.948 412.141 388.452 427.109 396.632 437.785L414.324 460.871L378.903 451.076C375.489 450.132 371.99 449.853 368.574 450.197C360.401 449.374 352.179 452.16 346.159 457.98L332.955 470.748L338.958 440.736C341.324 428.915 335.915 416.899 325.501 410.834L295.688 393.471L318.786 388.142C329.343 385.708 337.569 377.437 339.951 366.869Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M105.809 664.328L153.214 593.733C159.051 585.041 169.166 580.365 179.431 581.399C180.326 581.308 181.23 581.26 182.136 581.257C182.668 581.255 183.202 581.267 183.737 581.295C184.386 581.331 185.036 581.387 185.687 581.467C186.42 581.557 187.152 581.677 187.885 581.826C199.08 584.109 207.79 592.925 209.942 604.149L226.145 688.734L310.4 704.505C322.214 706.717 331.327 716.177 333.098 728.068C334.869 739.959 328.908 751.664 318.252 757.224L235.789 800.246L259.707 882.129C263.107 893.762 258.694 906.265 248.746 913.185C243.092 917.122 236.368 918.751 229.83 918.095C222.993 918.781 215.966 916.964 210.187 912.665L128.672 852.031L44.7758 887.386C40.3251 889.262 35.599 889.919 31.018 889.459C21.9402 890.373 12.7617 886.831 6.65172 879.591C-1.30641 870.165 -2.21308 856.657 4.41441 846.25L57.994 762.126L8.72934 700.414C1.51454 691.377 0.54914 678.846 6.29382 668.808C11.8384 659.123 22.546 653.654 33.5728 654.763C35.8174 654.536 38.1135 654.578 40.415 654.909L105.809 664.328ZM163.073 688.594L147.874 711.228C142.059 719.886 131.966 724.598 121.657 723.562C119.409 723.788 117.113 723.746 114.815 723.416L103.59 721.798L120.264 742.686C127.784 752.104 128.485 765.263 122.009 775.43L108.226 797.074L119.585 792.286C124.002 790.425 128.735 789.751 133.347 790.215C140.246 789.523 147.271 791.389 152.992 795.645L174.806 811.871L169.541 793.852C165.77 780.941 171.642 767.164 183.566 760.942L214.246 744.936L191.249 740.632C179.855 738.499 170.929 729.608 168.747 718.221L163.073 688.594Z"
                  fill="white"
                />
                <path
                  d="M519.534 571.319C517.528 571.063 515.531 571.057 513.58 571.281C503.743 570.153 494.165 575.008 489.26 583.64L452.198 648.856L395.227 644.934C393.749 644.83 392.283 644.862 390.846 645.019L389.588 644.934C379.463 644.235 369.939 649.796 365.566 658.96C361.19 668.126 362.853 679.033 369.758 686.48L416.901 737.305L375.491 814.465C370.369 824.009 372.042 835.779 379.623 843.515C385.08 849.085 392.688 851.634 400.116 850.781C404.848 851.324 409.748 850.504 414.203 848.222L485.259 811.825L559.925 859.203C564.822 862.311 570.5 863.521 575.992 862.893C582.459 863.634 589.125 861.81 594.413 857.513C602.666 850.804 605.713 839.567 601.98 829.603L575.703 759.459L645.074 716.409C654.04 710.847 658.493 700.206 656.167 689.91C653.844 679.613 645.251 671.924 634.766 670.757L559.992 662.441L540.295 589.428C537.68 579.74 529.481 572.588 519.534 571.319Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M611.069 1444.41C670.783 1441.52 710.406 1463.99 748.682 1500.27C767.278 1517.9 784.793 1538.07 804.29 1560.53L804.377 1560.63L808.567 1565.46C829.317 1589.33 852.129 1615.26 878.423 1639.19C936.644 1692.17 998.154 1728.01 1057.23 1742.16C1048.09 1749.56 1038.63 1757.14 1028.83 1764.9C848.88 1907.35 670.773 1844.62 590.267 1806.85C522.057 1774.85 502.924 1751.03 488.21 1726.16C472.055 1698.85 428.906 1708.2 428.967 1738.52C428.967 1746.64 428.924 1749.72 428.906 1751.03C428.894 1751.74 428.893 1751.92 428.909 1752.1L428.919 1752.18L428.926 1752.26L428.932 1752.3L428.967 1752.58C459.747 2025.98 691.84 2246.43 973.581 2246.43C1276.28 2246.43 1526.08 2000.27 1526.08 1697.7C1526.08 1658.06 1520.1 1612.34 1512.11 1575.09C1511.01 1569.99 1509.84 1565.21 1508.61 1560.76C1497.95 1509.39 1470.94 1474.11 1429.38 1469.48C1360.07 1461.78 1337.97 1483.59 1267.74 1552.88L1267.5 1553.12C1237.83 1582.39 1199.59 1620.11 1145.59 1667.64C1094.67 1682.4 1017.87 1662.58 929.913 1582.54C907.313 1561.97 887.135 1539.17 866.318 1515.21L865.088 1513.79L861.546 1509.72C842.638 1487.92 822.745 1465 801.311 1444.68C753.208 1399.09 694.249 1363.71 607.357 1367.93C528.676 1371.76 481.441 1426.38 455.368 1481.63C429.354 1536.73 420.074 1600.15 419.119 1642.02C418.636 1663.16 435.373 1680.69 456.498 1681.17C477.625 1681.65 495.143 1664.91 495.626 1643.77C496.416 1609.12 504.415 1557.02 524.565 1514.33C544.653 1471.77 572.466 1446.29 611.069 1444.41ZM1088.45 2147.29C1093.66 2126.24 1080.8 2104.95 1059.74 2099.75C1040.9 2095.09 1021.87 2104.89 1014.35 2122.08C1011.12 2127.79 1009.28 2134.38 1009.28 2141.4C1009.28 2163.09 1026.86 2180.68 1048.55 2180.68C1062.86 2180.68 1072.44 2173.31 1076.84 2168.87C1079.51 2166.19 1081.43 2163.51 1082.77 2161.34C1083.6 2159.98 1084.21 2158.82 1084.63 2157.99C1086.84 2153.51 1087.94 2149.33 1088.45 2147.29ZM1461.96 1695.46C1461.56 1675.31 1444.91 1659.29 1424.76 1659.69C1404.61 1660.08 1388.61 1676.75 1389.01 1696.91C1389.95 1744.93 1373.11 1826.8 1314.36 1920.49C1259.97 2007.21 1197.56 2039.88 1153.65 2062.85L1151.05 2064.2L1148.74 2065.41C1130.9 2074.78 1124.03 2096.85 1133.39 2114.7C1142.75 2132.55 1164.8 2139.43 1182.65 2130.06L1187.84 2127.34L1187.86 2127.33C1234.33 2103.04 1311.24 2062.84 1376.17 1959.29C1441.3 1855.43 1463.23 1759.75 1461.96 1695.46Z"
                  fill="white"
                />
              </svg>
            )}

            <h2
              ref={ref}
              className="
                font-recoleta
                text-title
                relative
                xl:pl-16
                xl:pr-48
                "
            >
              Who are the Magic Folk?
            </h2>
            <div className="mt-7">
              <div
                className="
                  text-summary
                  w-full
                  text-justify
                  font-sans 
                  text-sm
                  text-white
                  opacity-80
                  md:text-xl
                  xl:pl-16
                  xl:pr-48"
              >
                <p className="pb-6">
                  We are the magicians of Web3. There are two sides to our
                  collection: light and dark - just like our brand. Whether
                  it&rsquo;s lighthearted design, or serious tools, we are
                  creating superior user experiences throughout.
                </p>
                <p className="pb-6">
                  Magic Folk is a community of serious investors and builders
                  who don&rsquo;t take themselves too seriously. Join our quest
                  to bring Magic to Web3.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="fixed_target" className="c-fixed_target" />
        <div
          className="c-fixed"
          data-scroll
          data-scroll-sticky
          data-scroll-target="#fixed_target"
        >
          <div
            className="fixed bottom-[24vh] left-0 z-10 h-[100vh] w-full"
            style={{ perspective: "100px" }}
          >
            <div className="smoke fog-enter absolute left-0 bottom-0 h-full w-full">
              <div
                data-scroll
                data-scroll-speed="-2"
                className="fog1 absolute left-0 top-[60vh] w-[69.4vw] pt-[50%] opacity-30"
                style={{
                  backgroundImage: "url('/fog1.webp')",
                  backgroundSize: "100% auto",
                  backgroundRepeat: "no-repeat",
                }}
              />
              <div
                data-scroll
                data-scroll-speed="-3"
                className="fog2 absolute left-0 top-[65vh] w-[41.6vw] pt-[50%] opacity-50"
                style={{
                  backgroundImage: "url(/fog1.webp)",
                  backgroundSize: "100% auto",
                  backgroundRepeat: "no-repeat",
                }}
              />
              <div className="fog3 absolute left-0 top-[75vh] w-[62.5vw] pt-[50%] opacity-40">
                <span
                  data-scroll
                  data-scroll-speed="6"
                  className="relative block h-full w-full"
                  style={{
                    backgroundImage: "url(/fog1.webp)",
                    backgroundSize: "100% auto",
                    backgroundRepeat: "no-repeat",
                  }}
                ></span>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 z-20 h-[45vmin] w-full" data-scroll>
            <div
              data-scroll
              data-scroll-direction="horizontal"
              data-scroll-speed="-3"
              data-scroll-target="#p-who"
              className={`p-who--chars absolute w-[270vmin] ${
                isIOS ? "bottom-[42vh]" : "bottom-[30vh]"
              } -left-[15vw] h-[45vmin]`}
              style={{ transform: "translateX(-50%)" }}
            >
              {[...Array(6).keys()].map((i) => {
                let innerC = (
                  <img
                    src={chars[theme][i]}
                    alt="Wiz1"
                    className="block"
                    style={{
                      zIndex: 10,
                      transform: "scale(1.2) translateX(0%) translateY(0%)",
                      transformOrigin: "center",
                    }}
                  />
                )

                return (
                  <div key={i} className="relative inline-block w-[45vmin]">
                    {innerC}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeWho
